import type { UrlKeyValueTuple } from "./request.types";

export const paramsToQuery = (params: UrlKeyValueTuple) =>
  new URLSearchParams(params).toString();
